import store from '@/store'

function beforeEnter(to, from, next) {
    const { organization } = store.getters

    if (!organization.features.some((f) => f.feature === to.meta.organizationAllows)) {
        next('/404')
        return
    }

    next()
}

export default beforeEnter
